
import Vue from 'vue'
import App from './App'
import router from './router'
import VueHead from 'vue-head'
import LoadScript from 'vue-plugin-load-script'
import Vivus from 'vivus'
import Swiper from 'swiper'
import NProgress from 'nprogress'
import VueAnalytics from 'vue-analytics'

// Axios not working in IE11 even after using ES6-promise.
// https://github.com/axios/axios/issues/1694

Vue.use(VueHead)
Vue.use(LoadScript)

var imagesLoaded = require('@/assets/js/imagesloaded.pkgd.min.js')

// poor orphans
//window.Sierotki = require('sierotki').Sierotki

// globals

// event bus brrrr
export const eventBus = new Vue();

window.Vivus = Vivus
window.Swiper = Swiper
var $ = require('@/assets/js/jquery-2.2.4.min.js')


window.jQuery = window.$ = jQuery

Vue.config.productionTip = true

require('@/assets/css/normalize.css')
require('@/assets/css/style-vue.css')
require('@/assets/css/nprogress.css')


// analytics

Vue.use(VueAnalytics, {
  id: 'G-F3T7MPCXC4'
})

// scripts.js to functions.js @Mixin
import GlobalMixin from './functions.js'
Vue.use(GlobalMixin)

// configure from external source

fetch('/static/config.json').then(res => res.json()).then(config => {

  Vue.prototype.$config = config

  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  })


})






// WEBPACK FOOTER //
// ./src/main.js